import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSlackComponent } from './simple-icons-slack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSlackComponent ],
    exports:      [ SimpleIconsSlackComponent ],
    bootstrap:    []
})
export class SimpleIconsSlackModule {}
